import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { flatten, map, find } from "lodash";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { List, Typography, Button } from "@mui/material";
import { Box } from "@mui/system";
import Radio from "@mui/material/Radio";
import WordSpellCatagory from "../../../Components/UI/WordSpellCatagory";
import {
  getWords,
  shuffle,
  concatAllArraysWithDuplicate,
} from "../../../Js/Common";
import { calculateGenericScore } from "../../../Js/ScoreCalculate";
import { currentAssetSliceActions } from "../../../Store/Slices/CurrentAssetSlice";
import Confirmation from "../../../Components/Modal/Confirmation";
//import useSound from "use-sound";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const audio = new Audio();
var initLogObj = {
  attempts: 1,
  duration: 0,
  assetType: {
    group: "practice",
    value: null,
  },
  userAnswer: [],
  isEvaluated: "auto",
  actualAnswer: [],
  genericScore: 0,
};

const WS = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const classes = useStyles();
  let [userAnswer, setUserAnswer] = useState([]);
  let [logObj, setLogObj] = useState(initLogObj);
  let [groups, setGroups] = useState([]);
  let [words, setWords] = useState([]);
  let [visible, setVisible] = useState(false);
  let [currentGroupIndex, setCurrentGroupIndex] = useState(0);
  let [currentGroupWordIndex, setCurrentGroupWordIndex] = useState(0);
  let [currentWord, setCurrentWord] = useState(null);
  let [correctWords, setCorrectWords] = useState([]);
  let [shuffledWord, setShuffledWord] = useState([]);
  let [dropLetters, setDropLetters] = useState([]);
  let [alreadyCompletedWords, setAlreadyCompletedWords] = useState([]);
  let [currentAttemptWS, setCurrentAttemptWS] = useState(1);
  let [correct, setCorrect] = useState(false);
  let [showAnswer, setShowAnswer] = useState(false);

  const grid = 8;

  // const [play] = useSound(require('../../../assets/audio/abcd.mp3'), {
  //   sprite: {
  //     A: [270, 690],
  //     B: [1098, 955],
  //     C: [2241, 1219],
  //     D: [3677, 1057],
  //     E: [5072, 901],
  //     F: [6216, 839],
  //     G: [7342, 1065],
  //     H: [8675, 902],
  //     I: [9870, 833],
  //     J: [10948, 983],
  //     K: [12193, 1040],
  //     L: [13450, 906],
  //     M: [14612, 1008],
  //     N: [15816, 932],
  //     O: [16952, 904],
  //     P: [18172, 856],
  //     Q: [19403, 1098],
  //     R: [20888, 821],
  //     S: [22043, 811],
  //     T: [23151, 979],
  //     U: [24478, 979],
  //     V: [25705, 1015],
  //     W: [26996, 964],
  //     X: [28218, 974],
  //     Y: [29450, 983],
  //     Z: [30784, 784],
  //   },
  // });

  const { numberOfAttemptes, currentAttempt, attempedAnsLog } = useSelector(
    (state) => state.currentAsset
  );
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }));

  useEffect(() => {
    const innerFun = async () => {
      if (props.content) {
        setGroups(props.content.epage.options.content[0].source_groups);
        let wordsData = await getWords(
          flatten(
            map(props.content.epage.options.content[0].source_groups, "words")
          )
        );
        let correctAns = [];
        let newArr = wordsData.data.map((val, ind) => {
          correctAns.push(val.word_phrase.toUpperCase());
          return {
            ...val,
            content: typeof val.content == "string" ? JSON.parse(val.content) : val.content,
          };
        });
        //setWords(wordsData.data);
        setCorrectWords(correctAns);
        setCurrentWord(
          find(newArr, {
            uid: props.content.epage.options.content[0].source_groups[0][
              "words"
            ][0],
          })
        );
        setWords(newArr);
        setLogObj({
          ...logObj,
          assetType: {
            ...logObj.assetType,
            value: props.content.info.asset_type_alias,
          },
          actualAnswer: correctAns,
        });
      }
    };
    innerFun();
  }, [props.content]);

  useEffect(() => {
    dispatch(currentAssetSliceActions.setAssetLogObj(logObj));
  }, [logObj]);

  useEffect(() => {
    if (currentWord) {
      resetWord();
    }
  }, [currentWord]);

  useEffect(() => {
    if (userAnswer) {
      console.log("userAnswer", userAnswer);
      dispatch(currentAssetSliceActions.setCurrentAttemptData(userAnswer));
    }
  }, [userAnswer]);

  useEffect(() => {
    if (currentWord && shuffledWord.length == 0) {
      if (dropLetters.join("") == currentWord.word_phrase.toUpperCase()) {
        setCorrect(true);
      } else {
        setCurrentAttemptWS(currentAttemptWS + 1);
        setCorrect(false);
      }
      if (!showAnswer) {
        setTimeout(() => {
          setVisible(true);
        }, 500);
      }
    }
  }, [shuffledWord]);

  const newWord = () => {
    let arr = [...alreadyCompletedWords];
    arr.push(currentWord);
    setAlreadyCompletedWords(arr);
    if (groups[currentGroupIndex]["words"].length - 1 > currentGroupWordIndex) {
      setCurrentWord(
        find(words, {
          uid: groups[currentGroupIndex]["words"][currentGroupWordIndex + 1],
        })
      );
      setCurrentGroupWordIndex(currentGroupWordIndex + 1);
    } else {
      if (groups.length - 1 > currentGroupIndex) {
        setCurrentWord(
          find(words, {
            uid: groups[currentGroupIndex + 1]["words"][0],
          })
        );
        setCurrentGroupIndex(currentGroupIndex + 1);
        setCurrentGroupWordIndex(0);
      }
    }
    // if (
    //   groups.length - 1 == currentGroupIndex &&
    //   groups[currentGroupIndex]["words"].length - 1 == currentGroupWordIndex
    // ){
    //   dispatch(currentAssetSliceActions.setsubmitButtonShow(true));
    // }
    setCurrentAttemptWS(1);
  };

  const resetWord = () => {
    let arr = shuffle(currentWord.word_phrase.toUpperCase().split(""));
    setShuffledWord(arr);
    setDropLetters(new Array(arr.length).fill(" "));
  };

  const getImages = (arr) => {
    return arr.map((val, index) => {
      let foundObj = find(words, { uid: val });
      if (
        foundObj &&
        foundObj["content"] &&
        foundObj["content"][0]["media"]["image"]
      ) {
        return { uid: val, image: foundObj["content"][0]["media"]["image"] };
      }
      return { uid: val, image: null };
    });
  };

  const audioPlayPause = (audioSrc) => {
    if (!audio.paused) {
      audio.pause();
    }
    audio.src = `${sessionStorage.getItem(
      "media_url"
    )}words_media/audio/${audioSrc}`;
    audio.play();
  };

  const dragPlay = (dragindex) => {
    //play({ id: shuffledWord[dragindex] });
  };

  const allowDrop = (event) => {
    event.preventDefault();
  };

  const confirmAction = () => {
    if (correct) {
      getScore(1, currentWord.word_phrase);
      newWord();
    } else {
      if (currentAttemptWS <= numberOfAttemptes) {
        resetWord();
      } else {
        let arr1 = currentWord.word_phrase.toUpperCase().split("");
        setDropLetters(arr1);
        setShuffledWord([]);
        setShowAnswer(true);
      }
    }
    setVisible(false);
  };

  const drop = (event, dropindex) => {
    event.preventDefault();
    var data = event.dataTransfer.getData("dragindex");
    if (data) {
      let letter = shuffledWord[data];
      let arr1 = [...dropLetters];
      let alreadyLtr = arr1[dropindex];
      arr1.splice(dropindex, 1, letter);
      setDropLetters(arr1);
      let arr2 = [...shuffledWord];
      if (alreadyLtr.trim()) {
        arr2.splice(data, 1, alreadyLtr.trim());
      } else {
        arr2.splice(data, 1);
      }
      setShuffledWord(arr2);
      console.log("data", dropindex);
      console.log("dragindex", data);
    }
    //event.target.appendChild(document.getElementById(data));
  };

  const move = (source, destination, droppableSource, droppableDestination) => {
    var sourceClone, destClone;

    if (droppableSource.droppableId == "droppable") {
      sourceClone = Array.from(source);
      destClone = Array.from(destination);
    } else {
      sourceClone = Array.from(destination);
      destClone = Array.from(source);
    }
    const [removed] = sourceClone.splice(droppableSource.index, 1);

    destClone.splice(droppableDestination.index, 0, removed);

    const result = {};
    result[droppableSource.droppableId] = sourceClone;
    result[droppableDestination.droppableId] = destClone;

    console.log("result", result);

    return result;
  };

  // a little function to help us with reordering the result
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    padding: grid * 1,
    margin: `0px ${0}px 4px 8px`,
    // change background colour if dragging

    // styles we need to apply on draggables
    ...draggableStyle,
  });

  const getListStyle = (isDraggingOver) => ({
    display: "flex",
    overflow: "auto",
  });

  const onDragEnd = (result) => {
    console.log("res", result);
      const { source, destination } = result;

      // dropped outside the list
      if (!destination) {
        return;
      }

      if (
        source.droppableId !== "droppable" &&
        destination.droppableId !== "droppable"
      ) {
        return;
      }

      let dropId = result.destination.droppableId.split("_");
      if (source.droppableId === destination.droppableId) {
        if (source.droppableId === "droppable") {
          const items = reorder(shuffledWord, source.index, destination.index);
          setShuffledWord(items);
        }
      } else {
        let result1, newDrop;
        console.log("Ssource.droppableId",source.droppableId);
        if (source.droppableId === "droppable") {
          if (dropLetters[dropId[0]].trim().length > 0) {
            return;
          }

          result1 = move(
            shuffledWord,
            dropLetters[dropId[0]],
            source,
            destination
          );
          setShuffledWord(result1['droppable']);
          newDrop = result1[`${dropId[0]}_drop`];
          let innerArr = [...dropLetters];
          innerArr[dropId[0]] = newDrop[0];
          setDropLetters(innerArr);
        }
      }
  };

  const removeLetter = (event, index) => {
    if (!event.target?.innerText.trim()) {
      return false;
    }
    let letter = event.target.innerText;
    let arr1 = [...shuffledWord];
    arr1.push(letter);
    setShuffledWord(arr1);
    let arr2 = [...dropLetters];
    arr2.splice(index, 1, " ");
    setDropLetters(arr2);
  };

  const getScore = (score, word) => {
    //if (userInfo.rolesInfo.title.toLowerCase() == "learner") {
    let genericScore = calculateGenericScore(
      currentAttemptWS,
      numberOfAttemptes,
      score
    ).toFixed(2);
    console.log("genericScore", genericScore);

    let arr = [...userAnswer];
    arr.push({
      word: word.toUpperCase(),
      score: genericScore,
    });
    setUserAnswer(arr);
    //}
  };

  const getListStyle1 = (isDraggingOver) => ({
    display: "inline-flex",
    overflow: "auto",
    width: "auto",
  });

  return (
    <Grid item xs={12} sx={{}}>
      <DragDropContext onDragEnd={onDragEnd} onDragStart={(e) => {dragPlay(e.source.index)}}>
        {props.content && groups && words && (
          <Box
            sx={{
              borderRadius: 5,
              py: 2,
              mx: 6,
              mt: 1,
              height: "61vh",
            }}
          >
            <Grid
              container
              sx={{
                flexDirection: "row",
                flexFlow: "wrap",
                justifyContent: "center",
              }}
            >
              <Grid item xs={5} className={classes.scrollBar1}>
                {groups &&
                  groups.map((val, ind) => {
                    return (
                      <WordSpellCatagory
                        data={getImages(val.words)}
                        title={val.title}
                      />
                    );
                  })}
              </Grid>
              <Grid item xs={7} sx={{ textAlign: "center" }}>
                <Box sx={{}}>
                  <img
                    src={
                      currentWord &&
                      currentWord["content"] &&
                      currentWord["content"][0]["media"]["image"]
                        ? `${sessionStorage.getItem(
                            "media_url"
                          )}words_media/image/${
                            currentWord["content"][0]["media"]["image"]
                          }`
                        : require('../../../assets/spellitout.png')
                    }
                    style={{ borderRadius: "8px", cursor: "pointer" }}
                    width="65%"
                    onClick={() => {
                      if (
                        currentWord &&
                        currentWord["content"] &&
                        currentWord["content"][0]["media"]["audio"]
                      ) {
                        audioPlayPause(
                          currentWord["content"][0]["media"]["audio"]
                        );
                      }
                    }}
                  />
                  <Grid
                    container
                    sx={{
                      flexDirection: "row",
                      justifyContent: "center",
                      mt: 3,
                    }}
                  >
                    <Grid item xs={12}>
                      <Grid
                        container
                        sx={{
                          flexDirection: "row",
                          justifyContent: "center",
                        }}
                      >
                        {(dropLetters && !attempedAnsLog) &&
                          dropLetters.map((val, index) => {
                            return (
                              <Droppable
                                droppableId={`${index}_drop`}
                                direction="horizontal"
                                index={0}
                              >
                                {(provided, snapshot) => (
                                  <div
                                    ref={provided.innerRef}
                                    style={getListStyle1(
                                      snapshot.isDraggingOver
                                    )}
                                    {...provided.droppableProps}
                                  >
                                    <Grid
                                      item
                                      sx={{ ml: 1, cursor: "pointer", height: '2.2rem',"@media (min-width: 1636px)": {height: '2.6rem'} }}
                                    >
                                      <Item
                                        sx={
                                          val.trim().length == 0
                                            ? {
                                                lineHeight: 1,
                                                width: "0.65rem",
                                                height: "0.85rem",
                                                border: 1,
                                                borderColor: "#D9D9D9",
                                                "@media (min-width: 1636px)": {
                                                  minWidth: "1.25rem",
                                                  height: "1.45rem",
                                                },
                                              }
                                            : {
                                                lineHeight: 1,
                                                backgroundColor: "#e5ebff",
                                                color: "primary.main",
                                                fontWeight: "500",
                                                fontSize: "1.1rem",
                                                "@media (min-width: 1636px)": {
                                                  fontSize: "1.6rem",
                                                  minWidth: "1.25rem",
                                                  height: "1.45rem",
                                                },
                                              }
                                        }
                                        // onDrop={(event) => drop(event, index)}
                                        // onTouchEnd={(event) =>
                                        //   drop(event, index)
                                        // }
                                        // onDragOver={(event) => allowDrop(event)}
                                        // onTouchMove={(event) =>
                                        //   allowDrop(event)
                                        // }
                                        onDoubleClick={(event) =>
                                          removeLetter(event, index)
                                        }
                                      >
                                        {val}
                                      </Item>
                                    </Grid>
                                  </div>
                                )}
                              </Droppable>
                            );
                          })}
                        {/* {dropLetters &&
                          dropLetters.map((val, index) => {
                            return (
                              <Grid item sx={{ ml: 1, cursor: "pointer" }}>
                                <Item
                                  sx={
                                    val.trim().length == 0
                                      ? {
                                          lineHeight: 1,
                                          width: "0.65rem",
                                          height: "0.85rem",
                                          border: 1,
                                          borderColor: "#D9D9D9",
                                          "@media (min-width: 1636px)": {
                                            minWidth: "1.25rem",
                                            height: "1.45rem",
                                          },
                                        }
                                      : {
                                          lineHeight: 1,
                                          backgroundColor: "#e5ebff",
                                          color: "primary.main",
                                          fontWeight: "500",
                                          fontSize: "1.1rem",
                                          "@media (min-width: 1636px)": {
                                            fontSize: "1.6rem",
                                            minWidth: "1.25rem",
                                            height: "1.45rem",
                                          },
                                        }
                                  }
                                  onDrop={(event) => drop(event, index)}
                                  onTouchEnd={(event) => drop(event, index)}
                                  onDragOver={(event) => allowDrop(event)}
                                  onTouchMove={(event) => allowDrop(event)}
                                  onDoubleClick={(event) =>
                                    removeLetter(event, index)
                                  }
                                >
                                  {val}
                                </Item>
                              </Grid>
                            );
                          })} */}
                      </Grid>
                    </Grid>
                    <Grid item xs={12} sx={{ mt: 2 }}>
                      <Grid
                        container
                        sx={{
                          flexDirection: "row",
                          justifyContent: "center",
                        }}
                      >
                        <Grid
                          item
                          sx={{
                            cursor: "pointer",
                            cursor: "pointer",
                          }}
                        >
                          <Droppable
                            droppableId="droppable"
                            direction="horizontal"
                          >
                            {(provided, snapshot) => (
                              <div
                                ref={provided.innerRef}
                                style={getListStyle(snapshot.isDraggingOver)}
                                {...provided.droppableProps}
                                className={classes.scrollBarHeight}
                              >
                                {shuffledWord &&
                                  shuffledWord.length > 0 &&
                                  shuffledWord.map((item, index) => {
                                    return (
                                      <Draggable
                                        key={`${index}_drag`}
                                        draggableId={`${index}_drag`}
                                        index={index}
                                      >
                                        {(provided, snapshot) => (
                                          <Item
                                            sx={{
                                              lineHeight: 1,
                                              backgroundColor: "#e5ebff ",
                                              color: "primary.main",
                                              fontWeight: "500",
                                              fontSize: "1.1rem",
                                              "@media (min-width: 1636px)": {
                                                fontSize: "1.6em",
                                                minWidth: "1.25rem",
                                                height: "1.45rem",
                                              },
                                            }}
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            style={getItemStyle(
                                              snapshot.isDragging,
                                              provided.draggableProps.style
                                            )}
                                            // draggable="true"
                                            // onTouchStart={(e) => {
                                            //   drag(e, index1);
                                            // }}
                                            // onDragStart={(e) => {
                                            //   drag(e, index1);
                                            // }}
                                          >
                                            {item}
                                          </Item>
                                        )}
                                      </Draggable>
                                    );
                                  })}
                              </div>
                            )}
                          </Droppable>
                        </Grid>
                      </Grid>
                    </Grid>
                    {showAnswer && (
                      <Grid item xs={12}>
                        <Grid
                          container
                          sx={{
                            flexDirection: "row",
                            justifyContent: "space-around",
                          }}
                        >
                          <Grid item sx={{ ml: 1, cursor: "pointer" }}>
                            <Button
                              onClick={() => {
                                getScore(0, currentWord.word_phrase);
                                newWord();
                                setShowAnswer(false);
                              }}
                              variant="contained"
                              color="success"
                              fullWidth
                              sx={{
                                borderRadius: 10,
                                backgroundColor: "primary.success",
                                color: "#FFF",
                                fontWeight: "bold",
                                mt: 3,
                                px: 9,
                              }}
                            >
                              Next
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
                </Box>
              </Grid>
            </Grid>
            <Confirmation
              visible={visible}
              primaryText={correct ? "Congratulations !" : "Incorrect"}
              image={correct ? "complete" : "error"}
              persistent={true}
              toggleModal={(flag) => setVisible(flag)}
              //timeout={3000}
              confirmText={
                correct
                  ? "Next"
                  : currentAttemptWS <= numberOfAttemptes
                  ? "Try Again"
                  : "Show Answer"
              }
              confirm={confirmAction}
              onClose={() => {
                // setCorrect(false);
                // if (attempted && !correct) {
                //   checkShowAnswer();
                //   setAttempStatus(false);
                // }
              }}
              UX={true}
            ></Confirmation>
          </Box>
        )}
      </DragDropContext>
    </Grid>
  );
};
const useStyles = makeStyles({
  ListItemText: {
    fontSize: "1rem !important",
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
  scrollBar1: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
    height: "65vh",
    overflow: "auto",
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});
export default WS;
